import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
export function Hero() {
  const navigate = useNavigate();
  const {
    isAuthenticated
  } = useAuth();
  const handleOnboardingClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isAuthenticated) {
      navigate('/onboarding');
    } else {
      navigate('/auth/register', {
        state: {
          redirectTo: '/onboarding'
        }
      });
    }
  };
  return <div className="relative bg-gradient-to-br from-[#132C53] to-[#1e4278] text-white overflow-hidden" data-id="element-966">
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-967">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] bg-repeat" data-id="element-968"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 md:py-32" data-id="element-969">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-970">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6" data-id="element-971">
            Bine ai venit în ecosistemul
            <span className="block text-[#357BEB] mt-2" data-id="element-972">Cautlocuință.ro</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg sm:text-xl md:text-2xl text-gray-300 mb-6 sm:mb-8 max-w-3xl mx-auto px-4" data-id="element-973">
            Masterclass și proceduri - training-ul complet care te pregătește
            pentru succesul în industrie
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col sm:flex-row gap-4 justify-center items-center relative z-20" data-id="element-974">
            <Link to="/cursuri" className="inline-flex items-center space-x-2 bg-[#357BEB] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg hover:bg-[#2868d8] transition-all transform hover:scale-105 shadow-lg cursor-pointer" data-id="element-975">
              <span data-id="element-976">Începe training-ul</span>
              <ArrowRightIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-977" />
            </Link>
            <button onClick={handleOnboardingClick} className="inline-flex items-center space-x-2 bg-white text-[#132C53] px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg cursor-pointer" data-id="element-978">
              <span data-id="element-979">On-boarding</span>
              <ArrowRightIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-980" />
            </button>
          </motion.div>
        </motion.div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 pointer-events-none" data-id="element-981">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto" data-id="element-982">
          <path d="M0 120L1440 120L1440 0C1440 0 1080 80 720 80C360 80 0 0 0 0L0 120Z" fill="#F1F1F1" data-id="element-983" />
        </svg>
      </div>
    </div>;
}